import { Component, Host, h, Element, Prop, Event, EventEmitter, State } from '@stencil/core';
import { BreadcrumbsColor, BreadcrumbsVariant } from './breadcrumbs-interface';

/**
 * @slot - Main content of the breadcrumbs.
 *
 * @part breadcrumbs - Main breadcrumbs container.
 */
@Component({
  tag: 'o2-breadcrumbs',
  styleUrl: 'breadcrumbs.scss',
  shadow: true,
})
export class O2Breadcrumbs {
  @Element() private el!: HTMLO2BreadcrumbsElement;

  /**
   * Text color of breadcrumbs
   * @deprecated use variant instead
   */
  @Prop({ reflect: true }) color?: BreadcrumbsColor;

  /**
   * Variant of the breadcrumbs-item
   */
  @Prop({ reflect: true }) variant?: BreadcrumbsVariant = 'primary';

  /**
   * If slot dynamically changes, state change causes rerender of component
   */
  @State() slotChanged: number = 0;

  /**
   * Emits everytime when component did render
   */
  @Event() o2Ready!: EventEmitter<any>;

  private watchSlotChange = () => {
    const slot = this.el.shadowRoot.querySelector('slot');
    slot.addEventListener('slotchange', () => {
      this.slotChanged++;
    });
  };

  componentDidRender = () => {
    this.o2Ready.emit();
  };

  componentDidLoad = () => {
    this.watchSlotChange();
  };

  render() {
    const variant = this.color? this.color : this.variant;

    return (
      <Host>
        <div class={`breadcrumbs breadcrumbs--${variant}`} part="breadcrumbs">
          <slot />
        </div>
      </Host>
    );
  }
}
